module.exports = __webpack_public_path__ + "static/img/WechatIMG1991.62c6d332.jpeg";